module.exports = __webpack_public_path__ + "img/SignInImage.fa8896ed.png";